import React from "react";
import classes from "./CheckDetails.module.css";
import FBCommonUtil from "../../../../Fireboard/common";
import constants from "../../../../../globalization";
import MenuUtils from "../../../../../util/menu-utils";
import printIcon from "../../../../../assets/images/Fireboard/print.png";
import { fbInfo } from "../../../../../assets/images";
import classNames from "classnames";
import paidIcon from "../../../../../assets/images/Fireboard/paid.png";
import printSuccessIcon from '../../../../../assets/images/Fireboard/print_success.png';

const CheckItem = (props) => {
  const {
    item = {},
    qrFlow,
    onPrintPress = () => { },
    isPending,
    currency = '$',
  } = props;

  const renderModifiers = (mod, index) => {
    if (mod) {
      const modText =
        mod.quantity > 1
          ? `- ${mod.quantity} x ${mod.modifierName}`
          : `- ${mod.modifierName}`;
      const modString = `${modText} ${mod.price > 0 ? `(${currency} ${mod.price.toFixed(2)})` : ""
        }`;
      const note = mod.quantity > 1 ? `\t\t\t\t\t\t  ${mod.comment}` : `  \t\t\t  ${mod.comment}`;
      return (
        <>
          <span
            className={classes.checkCellView}
            style={{ paddingLeft: `${index * 1.5}vw`, width: "100%" }}
          >
            {modString}
          </span>
          {mod.comment ? (
            <span
              className={classNames(
                `${classes.checkCellView}`,
                `${classes.modNote}`
              )}
            >
              {note}
            </span>
          ) : null}
        </>
      );
    }
    return <span />;
  };

  const renderModifiersRecursively = (im) =>
    MenuUtils.renderModifiersRecursively(
      im,
      0,
      (i, index) => renderModifiers(i, index),
      (i) => { },
      true
    );

  const comment =
    item.quantity > 1 ? `\t\t\t  ${item.comment}` : `  ${item.comment}`;

  return (
    <div className={item.pending ? classNames(
      `${classes.itemContainer}`,
      `${classes.pendingBg}`,
    ) : classes.itemContainer}>
      <div className={classes.rowSpaceBetween}>
        <div className={classes.nameAndPrice}>
          <span
            className={
              item.printed
                ? classNames(
                  `${classes.checkCellView}`,
                  `${classes.name}`,
                  `${classes.printed}`
                )
                : classNames(`${classes.checkCellView}`, `${classes.name}`)
            }
          >
            {`${item.quantity > 1 ? `${item.quantity} x ` : ""}${item.menuItemName
              }`}
          </span>
          {item.comment ? (
            <span
              className={classNames(
                `${classes.checkCellView}`,
                `${classes.note}`
              )}
            >
              {comment}
            </span>
          ) : null}
        </div>
        {item.modifiers ? renderModifiersRecursively(item) : null}
      </div>
      <div className={classes.paidBtnWrapper}>
        {item?.paid ? <img src={paidIcon} alt="paid" className={classes.paidImg} /> : null}
      </div>
      <span
        className={classNames(
          `${classes.checkCellView}`,
          `${classes.price}`
        )}
      >
        {`${currency}${item && item.price && item.price.toFixed(2)}`}
      </span>
      <div className={classes.qrFlow}>
        {qrFlow || isPending ? null : (
          <button
            onClick={() => onPrintPress("item", item)}
            className={classes.itemPrintBtn}
          >
            <img
              src={item?.printed ? printSuccessIcon : printIcon}
              alt="print"
              className={classes.printIconSize}
            />
          </button>
        )}
      </div>
    </div>
  );
};

const CheckItems = (props) => {
  const {
    items = [],
    selectedItem = {},
    showMemberDetailPopup = () => { },
    posItemKeys = [],
    onPrintPress,
    isPending,
    relatedNotifications,
    acknowledgeIdCheck,
    // showApprovalReasonsPopup,
    currency = '$',
  } = props || {};

  const isPOSOrder =
  FBCommonUtil.getOrderTypeFromSourceType(selectedItem.sourceType) ===
    constants.orderType_POS;


  const invokeApproval = (notification, approval) => {
    const notificationTypeId = notification.notificationTypeId;
    if (notificationTypeId === 14) {
      acknowledgeIdCheck(approval, notification);
    } else if (notificationTypeId === 15) {
      // showApprovalReasonsPopup(approval, notification);
    }
  };

  const renderPOSCheck = (item) => {
    const itemWithMemberId =
      items && item && items[item] && Array.isArray(items[item])
        ? items[item].find((item) => !!item.section.memberId)
        : {};
    const memberId = itemWithMemberId
      ? itemWithMemberId?.section?.memberId
      : null;

    const seatId = isPending
      ? Array.isArray(items[item]) &&
      items[item][0] &&
      items[item][0].seatIds &&
      items[item][0].seatIds[0]
      : Array.isArray(items[item]) &&
      items[item][0] &&
      items[item][0].seats &&
      items[item][0].seats.length > 0 &&
      items[item][0].seats[0].seatId;

    const notification = relatedNotifications.filter(n => n.seatId === seatId);

    return (
      <div className={classes.checkItem}>
        {item ? (
          <button
            className={notification && notification.length > 0 ? [classes.itemSelected, classes.highlightSeat] : classes.itemSelected}
            onClick={() => !!memberId && showMemberDetailPopup(memberId)}
          >
            <span
              className={classes.selectedItemText}
              style={{
                color: item === constants.discountHeader ? "#AD0028" : "black",
              }}
            >
              {item}
            </span>
            {!!memberId && (
              <img src={fbInfo} className={classes.infoIconStyle} alt="info" />
            )}
          </button>
        ) : null}
        {Array.isArray(items[item]) && items[item].map((itemObj) => renderCheckItems(itemObj))}

        {notification && notification.length > 0
          ? notification.map(eachNotification =>
            eachNotification.notificationTypeId === 14 ? (
              <div
                className={classes.tableData}
              >
                <span className={classes.approvalLabel}>
                  {eachNotification.notificationTypeId === 14 ? 'ID CHECK' : 'OVER SERVE'}
                </span>
                <div
                  onClick={() => invokeApproval(eachNotification, false)}
                  className={classes.notBtn}
                >
                  <span className={classes.notificationBtnText}>
                    {constants.notification_reject}
                  </span>
                </div>
                <div
                  onClick={() => invokeApproval(eachNotification, true)}
                  className={classes.notBtn}
                >
                  <span className={classes.goAndDismissText}>
                    {constants.notification_approve}
                  </span>
                </div>
              </div>
            ) : null,
          )
          : null}
      </div>
    );
  };

  const renderCheckItems = (item, isPending) => {
    return (
      <CheckItem
        key={`checkItem-${item.id}`}
        item={item}
        selectedItem={selectedItem}
        onPrintPress={onPrintPress}
        currency={currency}
      />
    );
  };

  const checkItemsArray = isPOSOrder ? posItemKeys : items;

  return (
    <div className={classNames(`${classes.checkItemsContainer}`)}>
      {Array.isArray(checkItemsArray) && checkItemsArray.length
        ? checkItemsArray.map((item, itemIndex) => {
          if (isPOSOrder) {
            return <div key={`posItem-${itemIndex}`}>{renderPOSCheck(item)}</div>;
          }
          return <div key={`menuItem-${itemIndex}`}>{renderCheckItems(item)}</div>;
        })
        : null}
    </div>
  );
};

export default CheckItems;
